import api from "@/lib/api";
import { toast } from "sonner";

/**
 * Trigger a browser download of a CSV stream from a backend endpoint.
 * Uses axios (so auth cookies are sent) → Blob → hidden anchor click.
 */
export async function downloadCsv(path, filename) {
  try {
    const { data } = await api.get(path, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([data], { type: "text/csv" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success(`Downloaded ${filename}`);
  } catch (err) {
    toast.error(err.response?.status === 403 ? "Admin access required" : "Download failed");
  }
}
